import React from 'react';
import Button from '../common/Button';
const config = require('../../config/config');

const Donations = () => {
  return (
    <div className="flex flex-col gap-y-4">
      <h1 className="text-2xl text-center">Donaciones</h1>
      <h4>
        ManaValue es un proyecto desarrollado entre amigos y fanáticos de Magic,
        para ayudar a la comunidad a conseguir las cartas que buscan lo más
        barato y rápido posible.
      </h4>
      <h4>
        Lo que comenzó como una app para uso interno está creciendo, y con ese
        crecimiento, crecen los costos para mantenerla funcionando.
      </h4>
      <h4>
        Si querés ayudarnos a que ManaValue siga operando, y que sigamos
        agregándole nueva funcionalidad, podés donarnos el equivalente a algunas
        tierras básicas para fortalecer nuestra base de maná.
      </h4>
      {config.donationLinks.map(donationLink => (
        <a
          key={donationLink.url}
          href={donationLink.url}
          target="_blank"
          rel="noopener noreferrer">
          <Button className="w-full " iconClass="fas fa-dollar-sign">
            {donationLink.name}
          </Button>
        </a>
      ))}
      <h1 className="text-2xl text-center">¡Gracias!</h1>
    </div>
  );
};

export default Donations;
